import React from 'react';
import { ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { BookItem } from '../Elze/BookItem';
import { Book } from '../../data/books';
interface AuthorWorksCarouselProps {
  works: Book[];
  currentBookId: string;
  authorId: string;
  authorName: string;
}
export function AuthorWorksCarousel({
  works,
  currentBookId,
  authorId,
  authorName
}: AuthorWorksCarouselProps) {
  const navigate = useNavigate();
  // Filtra le opere per mostrare solo quelle dell'autore corrente e non il libro corrente
  const authorWorks = works.filter(work => work.author.id === authorId && work.id !== currentBookId);
  // Se non ci sono altre opere dell'autore, non mostrare il carosello
  if (authorWorks.length === 0) {
    return null;
  }
  // Funzione per gestire il click su un libro - standardizzata
  const handleBookClick = (bookId: string) => {
    navigate(`/book/${bookId}`);
  };
  // Funzione per gestire il click sul pulsante "Vedi tutte"
  const handleViewAllClick = () => {
    navigate(`/profile/${authorId}`);
  };
  return <div className="bg-white rounded-lg border border-gray-200/70 shadow-sm" data-id="element-46">
      {/* Header */}
      <div className="flex items-center justify-between px-4 sm:px-6 py-4 border-b border-gray-100" data-id="element-47">
        <div className="flex items-center" data-id="element-48">
          <h2 className="text-base font-semibold text-gray-900" data-id="element-49">
            Altre opere di {authorName}
          </h2>
        </div>
        <div data-id="element-50">
          <button onClick={handleViewAllClick} className="text-sm text-[#161c2d] flex items-center hover:underline" data-id="element-51">
            Vedi tutte <ChevronRight size={16} data-id="element-52" />
          </button>
        </div>
      </div>
      {/* Contenitore libri con scroll orizzontale migliorato */}
      <div className="px-4 sm:px-6 py-5 relative" data-id="element-53">
        {/* Left shadow indicator */}
        <div className="absolute top-5 left-4 sm:left-6 bottom-5 w-8 bg-gradient-to-r from-white to-transparent pointer-events-none z-10 hidden sm:block" data-id="element-54"></div>
        {/* Improved carousel container */}
        <div className="overflow-x-auto scrollbar-hide -mx-1 px-1" data-id="element-55">
          <div className="flex space-x-4 sm:space-x-5 w-max whitespace-nowrap" data-id="element-56">
            {authorWorks.map(work => <div key={work.id} className="w-[200px] flex-shrink-0" data-id="element-57">
                <BookItem cover={work.cover} title={work.title} genre={work.genre} year={work.year} id={work.id} authorName={work.author.name} authorImage={work.author.image} onClick={() => handleBookClick(work.id)} data-id="element-58" />
              </div>)}
          </div>
        </div>
        {/* Right shadow indicator */}
        <div className="absolute top-5 right-4 sm:right-6 bottom-5 w-8 bg-gradient-to-l from-white to-transparent pointer-events-none z-10 hidden sm:block" data-id="element-59"></div>
        {/* Mobile scroll indicator */}
        <div className="text-xs text-gray-500 text-center mt-2 sm:hidden" data-id="element-60">
          ← Scorri orizzontalmente →
        </div>
      </div>
    </div>;
}